import { render } from "./IssueArticleContent.vue?vue&type=template&id=0c309a82&scoped=true"
import script from "./IssueArticleContent.vue?vue&type=script&lang=js"
export * from "./IssueArticleContent.vue?vue&type=script&lang=js"

import "./IssueArticleContent.vue?vue&type=style&index=0&id=0c309a82&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3595080301/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c309a82"]])

export default __exports__